module.exports = __webpack_public_path__ + "img/news-img3.52c4d7d1.svg";